import * as React from 'react'
import {useEffect} from 'react'
import {useAppContextState} from "app/@hooks";
import {createContext} from "use-context-selector";

const Context = createContext({})

const readIdReportExecutionFromUrl = () => {
	const v = new URLSearchParams(window.location.search).get('id_report_execution')
	return v ? Number(v) : null
}

export function ParityReportExecutionProvider({children}) {
	const { state, updateState, resetState } = useAppContextState({ idReportExecution: readIdReportExecutionFromUrl(), weekdays: null })

	useEffect(() => {
		if (new URLSearchParams(window.location.search).get('id_report_execution')) {
			window.history.replaceState({}, '', window.location.pathname)
		}
	}, [])

	return <Context.Provider value={{state, updateState, resetState}}>
		{children}
	</Context.Provider>
}

export default Context
